<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgement</h1>
<p>A big thank you to all of those that encouraged me in my creative writing – you know who you are. Especially my husband Pat, for being a sounding board and reading all my chapters with enthusiasm and becoming my book reviewer – even though he much prefers vintage car magazines! To the other four men in my life, my sons, thanks for the help and interest shown. Darragh – my all-things technical man; Seán – the drummer who managed to keep the music down while I was writing. Joseph who helped with the proofreading and showed great patience. Patrick who is not really into books but might make an exception for this one.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?3d2b544d